/* COCO: product card badges read on any photo. Checks how bright the top-left of each card photo is
   (where the badges sit) using a tiny 48px copy of the image, and switches the badges to white on dark photos. */
(() => {
  const SAMPLE_WIDTH = 48;
  const DARK_THRESHOLD = 0.4; /* black by default; white only when the corner is clearly dark */
  const checked = new WeakSet();

  const sampleUrl = (img) => {
    const src = img.currentSrc || img.src;
    if (!src) return null;
    const url = new URL(src, location.href);
    url.searchParams.set('width', SAMPLE_WIDTH);
    return url.toString();
  };

  const check = (card) => {
    if (checked.has(card)) return;
    const list = card.querySelector('.product-card__badge-list');
    const img = card.querySelector('img.product-card__image--primary');
    const src = list && img ? sampleUrl(img) : null;
    if (!src) return;
    checked.add(card);

    const probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = probe.naturalWidth;
        canvas.height = probe.naturalHeight;
        const ctx = canvas.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(probe, 0, 0);
        const { data } = ctx.getImageData(0, 0, Math.max(1, Math.round(canvas.width * 0.5)), Math.max(1, Math.round(canvas.height * 0.18)));
        let total = 0;
        for (let i = 0; i < data.length; i += 4) total += 0.2126 * data[i] + 0.7152 * data[i + 1] + 0.0722 * data[i + 2];
        list.classList.toggle('product-card__badge-list--on-dark', total / (data.length / 4) / 255 < DARK_THRESHOLD);
      } catch (e) {
        /* image could not be read: keep the default black badge */
      }
    };
    probe.src = src;
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      check(entry.target);
    });
  }, { rootMargin: '300px' });

  const watch = (root) => root.querySelectorAll('product-card').forEach((card) => observer.observe(card));
  watch(document);

  /* cards added later (filters, pagination, quick view) */
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node.nodeType !== 1) return;
      node.matches('product-card') ? observer.observe(node) : watch(node);
    }));
  }).observe(document.body, { childList: true, subtree: true });
})();
